import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import PageHeaderText from 'components/base/page-header-text';
import useNewMealXlsContext from 'contexts/new-meal-xls.context';
import React from 'react';

const TABLE_HEADERS = ['Item name', 'Category', 'Item price', 'Weight/volume', 'Size', ''];
const ReviewShopMeal = () => {
  const { meals, setMeals } = useNewMealXlsContext();

  return (
    <section>
      <PageHeaderText
        title='Item details'
        description='Review and confirm uploaded items'
        tagText={`${meals?.length} ${meals?.length === 1 ? 'item' : 'items'} found`}
      />
      <div className='no-scroll-bar whitespace-nowrap pb-10 border border-gray-1 rounded-xl'>
        {meals && meals.length > 0 ? (
          <Table headers={TABLE_HEADERS}>
            {meals.map((meal, idx) => (
              <TableRow key={idx}>
                <TableData>{meal.name}</TableData>
                <TableData className=''>{meal.category}</TableData>
                <TableData>₦{meal.price.toLocaleString('en-US')}</TableData>
                <TableData>{meal.weight}</TableData>
                <TableData className=''>{meal.size}</TableData>

                <TableData className='flex items-center gap-3'>
                  <DeleteIcon
                    onClick={() => setMeals(meals.filter((shopMeal) => shopMeal.id !== meal.id))}
                    className='cursor-pointer text-red-5 hover:bg-red-1 w-5 h-5 transition-all p-[3px] rounded'
                  />
                </TableData>
              </TableRow>
            ))}
          </Table>
        ) : (
          <div className='text-center mt-4'>There are no items available</div>
        )}
      </div>
    </section>
  );
};

export default ReviewShopMeal;
